import React, { useEffect, useRef, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
} from "react-icons/pi";
import { batchUploadFileBulk, cancelBulkDebitApi, debittingCountApi, faAppReport, getAllBulkDebitStatus, getAllWorkflowMandates, mailReportApi, mailworkFlowReportApi, smsworkFlowReportApi, workFlowReportApi } from '../services';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router';
import ReactPaginate from 'react-paginate';
import LoadingModal from '../components/modals/LoadingModal';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { ModalBulkDebitModal } from '../components/modals/ModalBulkDebitNew';
import * as XLSX from "xlsx";
import { notify } from '../components/actions/CommonActions';
import { ModalCancelBulkDebit } from '../components/modals/ModalCancelBulkDebit';

const AllBulkDebitStatus = () => {
    const [allMandates, setAllMandates] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0); // For total pages
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [limit, setLimit] = useState(20)
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [batchId, setBatchId] = useState(null)
    const dropdownRef = useRef(null);
    const [mandateInfo, setMandateInfo] = useState(null)
    const navigate = useNavigate()
    const [modalUploadExcel, setModalUploadExcel] = useState(false)
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [uploadedFile, setUploadedFile] = useState(null)
    const [isUploaded, setIsUploaded] = useState(false)
    const [note, setNote] = useState("")
    const [mandateData, setMandateData] = useState(null)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false);

    const WORKFLOWSTATUS = {
        BILLER_INITIATED: 1,
        BILLER_AUTHORISED: 2,
        BILLER_REJECTED: 3,
        BILLER_APPROVED: 4,
        BANK_AUTHORIZED: 6,
        BANK_REJECTED: 7,
        BANK_APPROVED: 8,
        BANK_DISAPPROVED: 9,
    };

    const handleAllMandates = async (page, limit) => {
        const params = {
            limit: limit,
            page: page,
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });

        await getAllBulkDebitStatus(searchParams)
            .then((res) => {
                //   console.log("all bulk debit res ", res?.data?.data);
                setAllMandates(res?.data?.data)
                setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                console.log('err ', err);
            })
    }

    const handlePageClick = async (data) => {
        setIsLoading(true);
        let selectedPage = data.selected + 1; // react-paginate uses 0-based index, so add 1
        setCurrentPage(selectedPage); // Update current page state
        await handleAllMandates(selectedPage, limit)
        setIsLoading(false);
    };


    useEffect(() => {
        const initiate = async () => {
            setLoading(true)
            await handleAllMandates(currentPage, limit)
            setLoading(false)
        }
        initiate()
    }, [])

    const toggleDropdown = (id, mandateCode, mandate) => {
        setOpenDropdownId(id);
        setBatchId(mandateCode)
        setMandateInfo(mandate)
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // console.log("e. target ",e.target.files[0]);
        setUploadedFile(file)
        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Define the expected headers
                const expectedHeaders = [
                    "contractId",
                ]; // Replace with your expected headers

                // Get the headers from the first row of the Excel file
                const headersInFile = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1,
                })[0];

                // Check if the headers in the file match the expected headers
                const isValidFile = expectedHeaders.every((header) =>
                    headersInFile.includes(header)
                );

                if (!isValidFile) {
                    notify(
                        "danger",
                        "Invalid file",
                        "Invalid file structure. Please upload a file with the correct headers."
                    );
                    return;
                }

                // const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                // Assuming the first row contains headers/names for the properties
                const headers = headersInFile;

                // Create an array of objects using headers as property names
                // const dataArray = excelData.slice(1).map((row) => {
                //   const obj = {};
                //   headers.forEach((header, index) => {
                //     obj[header] = row[index];
                //   });
                //   return obj;
                // });

                const dataArray = XLSX.utils
                    .sheet_to_json(worksheet, { header: 1 })
                    .slice(1)
                    .map((row) => {
                        const obj = {};
                        row.forEach((cell, index) => {
                            // Check if the cell is a date and convert it to JS Date
                            if (headers[index] && worksheet[`${headers[index]}_t`] === "n") {
                                const dateCode = cell;
                                const jsDate = XLSX.SSF.parse_date_code(dateCode);
                                obj[headers[index]] = jsDate;
                            } else {
                                obj[headers[index]] = cell;
                            }
                        });
                        return obj;
                    });

                //   setAllMandates(dataArray);
                // console.log("data Array ", dataArray);
                
                dataArray?.length > 0 ? setIsUploaded(true) : setIsUploaded(false);
            };

            reader.readAsBinaryString(file);
        }
    }

    const handleUploadFile = async () => {
        setModalUploadExcel(false)
        const file = uploadedFile

        const originalDate = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').toISOString();
        //   console.log("file ", file, note, originalDate);
        const formData = new FormData()
        formData.append('file', file)
        formData.append('description', note)
        formData.append('runAt', originalDate)
        setIsLoading(true)
        await batchUploadFileBulk(formData)
            .then(async (res) => {
                setIsLoading(false);
                //   console.log("all mandates to debit res ", res?.data);
                notify("success", "Mandate debit uploaded successfully.", `${res?.message}`);
                setLoading(true)
                await handleAllMandates(currentPage, limit)
                setLoading(false)
                //   navigate('/all-new-mandates')
            })
            .catch((err) => {
                setIsLoading(false);
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
    }

    
        const handleCancelDebit = async (mandate) => {
            setIsDeleting(true)
            await cancelBulkDebitApi(mandate?.sessionId)
                .then(async (res) => {
                    setAllMandates((prev) =>
  prev.map((each) =>
    each.sessionId === mandate?.sessionId ? { ...each, status: "cancelled" } : each
  )
);
                    //   console.log("all transaction res ", res?.data);
                    // await setIsDeleting(false)
                    // await setHistory(res)
                    // setShowSingleDebitModal(false)
                    // setFaReport(res?.data)
                })
                .catch((err) => {
                    setIsDeleting(false)
                    notify("danger", "OOPS", `${err?.response?.data?.message}`);
                    // console.log('err ', err);
                })
        }

        const downloadCSV = () => {
  const header = 'contractId\n';
  const rows = mandateInfo?.mandateNotFound.join('\n');
  const csvContent = header + rows;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'contract_ids.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

    return (
        <>
            {loading ? (
                <div className="typewriter-container">
                    <div class="typewriter">
                        <div class="slide">
                            <i></i>
                        </div>
                        <div class="paper"></div>
                        <div class="keyboard"></div>
                    </div>
                    <code style={{ color: "#000" }}>Getting your app ready...</code>
                </div>
            ) : (
                <div style={{ overflowX: "auto" }}>

                    {/* <form onSubmit={async(e)=> {
            e.preventDefault()
            setIsLoading(true);
            await handleAllMandates(1, 10)
            setIsLoading(false);
        }} style={{display: "flex", justifyContent: "flex-end", padding: "10px 0", gap: "10px"}}>
            <input type="text" onChange={(e)=> setSearch(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
            <button type="submit" style={{border: "none", backgroundColor: "#007dcc", color: "white", padding: "0px 10px", borderRadius: "5px"}}>Search</button>
        </form> */}
                    <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
                        <button type="button" onClick={() => setModalUploadExcel(true)} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "10px 10px", borderRadius: "5px", marginleft: "10px", marginRight: "10px" }}>Upload Excel</button>
                    </div>
                    {/* <h5 className='mt-3'>Sms Report</h5> */}
                    <table className="fl-table">
                        <thead>
                            <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                                {/* Table header cells */}
                                {/* Modify according to your data structure */}
                                <th width="20%">Session Id</th>
                                <th width="20%">Status</th>
                                <th>Status</th>
                                {/* <th>Total Records</th>
                                <th>Processed Records</th>
                                <th>Successful Records</th>
                                <th>Failed Records</th> */}
                                <th>Initiated by</th>
                                <th>Debit date/time</th>
                                <th>Created At</th>
                                <th>...</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                allMandates?.map((mandate) => (
                                    <tr
                                        className="tr"
                                        key={mandate.id}
                                    >
                                        <td className="gray-td">{mandate?.sessionId}</td>
                                        <td className="gray-td">{mandate?.status}</td>
                                        <td>
                                        <div style={{borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "gold"}}>Processed Records:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "gold"}}>{mandate?.processedRecords}</p>
                                            </div><div style={{borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "green"}}>Successful Records:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "green"}}>{mandate?.successfulRecords}</p>
                                            </div><div style={{borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "red"}}>Failed Records:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "red"}}>{mandate?.failedRecords}</p>
                                            </div>
                                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500"}}>Total Records:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500"}}>{mandate?.totalRecords}</p>
                                            </div>
                                        </td>
                                        {/* <td className="gray-td">{mandate?.totalRecords}</td>
                                        <td className="gray-td">{mandate?.processedRecords}</td>
                                        <td className="gray-td">{mandate?.successfulRecords}</td>
                                        <td className="gray-td">{mandate?.failedRecords}</td> */}
                                        <td className="gray-td">{mandate?.initiatedBy}</td>
                                        <td className="gray-td">
  {moment(mandate?.runAt).format('DD MMM, YYYY')} &nbsp; &nbsp; {moment(mandate?.runAt).format('hh:mm A')}
</td>
                                        <td className="gray-td">{moment(mandate?.createdAt).format('DD MMM, YYYY')}</td>
                                        <td style={{ textAlign: "center" }} >
                                            <div className="relative" style={{ position: "relative" }}>
                                                <button
                                                    onClick={() => toggleDropdown(mandate?.id, mandate?.id, mandate)}
                                                    className="dotsBtn"
                                                >
                                                    <HiOutlineDotsVertical />
                                                </button>

                                                {openDropdownId === mandate?.id && (
                                                    <div className="dropdownSelect" ref={dropdownRef} style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)', zIndex: 100, backgroundColor: "white" }}>
                                                        <div className="updateBtn">
                                                            <button
                                                                onClick={() => {
                                                                    navigate(`/all-bulk-debit-mandate/${mandate?.sessionId}`)
                                                                }}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                View details
                                                            </button>
                                                        </div>
                                                        <div className="updateBtn">
                                                            <button
                                                                onClick={downloadCSV}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                View invalid policy
                                                            </button>
                                                        </div>
                                                        
                                                        <div className="updateBtn">
                                                            <button
                                                                onClick={async () => {
                                                                    setMandateData(mandate)
                                                                    setShowCancelModal(true)
                                                                    // await handleCancelDebit(mandate)
                                                                }}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                Cancel debit
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount} // Total pages from API
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={currentPage - 1}
                    />
                    <LoadingModal show={isLoading} />
                    <ModalBulkDebitModal
                        show={modalUploadExcel}
                        toggle={() => setModalUploadExcel(!modalUploadExcel)}
                        date={date}
                        time={time}
                        setDate={setDate}
                        setTime={setTime}
                        handleFileChange={handleFileChange}
                        handleUploadFile={handleUploadFile}
                        note={note}
                        setNote={setNote}
                    />
                    <ModalCancelBulkDebit show={showCancelModal} toggle={()=> setShowCancelModal(false)} handleDeleteMandate={ () => handleCancelDebit(mandateData)} mandate={mandateData} isDeleting={isDeleting} />
                </div>
            )}
        </>
    )
}

export default AllBulkDebitStatus